import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const InformationForm = ({
  register,
  handleSubmit,
  errors,
  onSubmit,
  watch,
  setTabs,
}) => {
  return (
    <div className="space-y-5 px-1 py-10 ">
      <div>
        <label className="block font-medium mb-1">Title</label>
        <input
          type="text"
          {...register("title", { required: true })}
          placeholder="Enter title "
          className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
        />
        {errors.title && (
          <p className="text-sm text-red-500">title is required</p>
        )}
      </div>

      <div>
        <label className="block font-medium mb-1">Goal Amount</label>
        <input
          type="text"
          {...register("amount", { required: true })}
          placeholder="Enter the Goal Amount "
          className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
        />
        {errors.amount && (
          <p className="text-sm text-red-500">amount is required</p>
        )}
      </div>
      <div className="flex flex-col sm:flex-row gap-4">
        {/*  Start Date */}
        <div className="w-full sm:w-1/2">
          <label className="block font-medium mb-1">Start Date</label>
          <input
            type="date"
            {...register("startDate", { required: true })}
            className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
          />
          {errors.startDate && (
            <p className="text-sm text-red-500">Start date is required</p>
          )}
        </div>

        {/*  End Date */}
        <div className="w-full sm:w-1/2">
          <label className="block font-medium mb-1">End Date</label>
          <input
            type="date"
            {...register("endDate", {
              required: "End date is required",
              validate: (value) =>
                new Date(value) >= new Date(watch("startDate")) ||
                "End date must be after Start date",
            })}
            className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
          />
          {errors.endDate && (
            <p className="text-sm text-red-500">End date is required</p>
          )}
        </div>
      </div>
      <div>
        <label className="block font-medium mb-1">Category</label>
        <input
          type="text"
          {...register("category", { required: true })}
          placeholder="Enter the Category "
          className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
        />
        {errors.category && (
          <p className="text-sm text-red-500">category is required</p>
        )}
      </div>
      {/* <button
          type="submit"
          className="px-6 py-2 mt-4 bg-green-800 text-white rounded-full hover:bg-green-900"
        >
          Save
        </button> */}

      <div className="flex justify-between mt-6">
        <button
          onClick={() => setTabs(1)}
          type="button"
          className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
        >
          <span>
            <FaAngleLeft />
          </span>
          Back
        </button>

        {/* ✅ use handleSubmit to validate before moving next */}
        <button
          type="button"
          onClick={handleSubmit(() => setTabs(2))}
          className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
        >
          Next
          <span>
            <FaAngleRight />
          </span>
        </button>
      </div>
    </div>
  );
};

export default InformationForm;
